/**
 * Premium Slice Compatibility Layer
 * This file re-exports from premiumSliceSimple for backward compatibility
 * while we migrate to the simpler RevenueCat integration
 */

// Additional compatibility exports for features that don't exist in simple slice
import { RootState } from '../index';
import { PremiumFeature } from '../../types/premium';

// Re-export everything from the simple slice
export * from './premiumSliceSimple';

// Re-export the reducer as default
export { default } from './premiumSliceSimple';

// Mock features for now - the simple slice just tracks isPeakSub
export const selectPremiumFeatures = (state: RootState) => {
  const features: PremiumFeature[] = [];
  // Check both RevenueCat subscription AND admin-granted Peak
  if (state.premium.isPeakSub || state.premium.adminGrantedPeak) {
    // If user has peak subscription, they have all features
    features.push(
      PremiumFeature.INJURY_TRACKING,
      PremiumFeature.PHOTO_GALLERY,
      PremiumFeature.CUSTOM_METRICS,
      PremiumFeature.AD_FREE,
      PremiumFeature.GOALS,
      PremiumFeature.WORKOUT_ROUTINES,
      PremiumFeature.INSIGHTS,
      PremiumFeature.ROUND_TRACKER,
      PremiumFeature.MULTIPLE_MARTIAL_ARTS,
      PremiumFeature.LEADERBOARDS
    );
  }
  return features;
};

export const selectHasFeature = (_featureId: PremiumFeature) =>
  (state: RootState) => {
    // If user has peak subscription (RevenueCat OR admin-granted), they have all features
    return state.premium.isPeakSub || state.premium.adminGrantedPeak;
  };

// Mock active subscriptions (not in simple slice)
export const selectActiveSubscriptions = (state: RootState) => state.premium.activeSubIDs;

// Mock peak insights (not in simple slice)
export const selectPeakInsights = (_state: RootState) => [];

// Mock actions that don't exist in simple slice
export const fetchPeakInsights = () => async () => {
  // No-op for now
  return [];
};

export const redeemPromoCode = (_code: string) => async () => {
  // No-op for now
  throw new Error('Promo code redemption not implemented');
};

// Mock setEntitlements for compatibility
export const setEntitlements = (_entitlements: any) => ({
  type: 'premium/setEntitlements',
  payload: _entitlements
});

// Alias for compatibility - includes admin-granted Peak fallback
export const selectIsPremium = (state: RootState) => state.premium.isPeakSub || state.premium.adminGrantedPeak;
export const selectOfferings = (state: RootState) => state.premium.availableOfferings;